<template>
  <div class="research_group_container">
    <div class="hd research-background-color">
      <!--<span class="icon icon-left navshare" @click="$emit('toggleShow')"></span>-->
      <span class="header_title">合同详情</span>
      <svg class="arrow_down" @click="$emit('toggleShow')" width="6.5vw" height="6.5vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z" fill="#ffffff" /></svg>
    </div>
    <div class="box">
      <div class="outer_3" v-if="contractInfo">
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">合同名称</span>
            <span class="attr">{{contractInfo.contractName}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">合同编号</span>
            <span class="attr">{{contractInfo.contractNo}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">线下合同编号</span>
            <span class="attr">{{contractInfo.contractNoOffline}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">合同金额</span>
            <span class="attr">¥{{splitMoney(contractInfo.contractMoney)}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">付款方式</span>
            <span class="attr">{{contractInfo.payTypeString}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr" v-if="type==='交付' && selected === '累计'">
          <div class="group">
            <span class="attr_name">合同是否结清账款</span>
            <span class="attr">{{contractInfo.isSettledString}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr" v-if="type==='交付' && selected === '累计'">
          <div class="group">
            <span class="attr_name">未结清账款金额</span>
            <span class="attr">¥{{contractInfo.notSettledMoneySum && splitMoney(contractInfo.notSettledMoneySum.toFixed(2))}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">业务员</span>
            <span class="attr">{{contractInfo.employeeName}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">签署客户名称</span>
            <span class="attr">{{contractInfo.signedCustomerName}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">签署客户单位</span>
            <span class="attr">{{contractInfo.signedEnterpriseName}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">合同启动日期</span>
            <span class="attr">{{contractInfo.contractStartDT}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">生产状态</span>
            <span class="attr">{{contractInfo.produceStatusString}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">预计生产完结日期</span>
            <span class="attr">{{contractInfo.expectedProduceEndDT}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">发货状态</span>
            <span class="attr">{{contractInfo.deliveryStatusString}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr">
          <div class="group">
            <span class="attr_name">发货日期</span>
            <span class="attr">{{contractInfo.deliveryDT}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr" v-if="type === '消费'">
          <div class="group">
            <span class="attr_name">待收账户余额</span>
            <span class="attr">¥{{contractInfo.waitPrepayAmount && splitMoney(contractInfo.waitPrepayAmount.toFixed(2))}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
        <div class="outer_attr" v-if="type === '交付'">
          <div class="group">
            <span class="attr_name">待收尾款</span>
            <span class="attr">¥{{contractInfo.waitRetainage && splitMoney(contractInfo.waitRetainage.toFixed(2))}}</span>
          </div>
          <div class="container"><div class="empty" /></div>
        </div>
      </div>
      <div style="height:10vw;"></div>
    </div>
  </div>
</template>
<script>
// import {mapGetters} from 'vuex'
// import EMKT from '../../../../emkt'
export default {
  props: [
    'contractInfo', 'type', 'selected'
  ],
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:auto;
  overflow-x:hidden;
  background-color: #efeef3;
  position: fixed;
  top: 0;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}
.box {
  /*display: flex;*/
  position: relative;
  /*align-items: center;*/
  /*flex-direction: column;*/
  background-color: #efeef3;
  width: 100vw;
  height: 100vh;
  top: 14.93vw;
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}
.arrow_down {
  position: absolute;
  right: 8vw;
  margin-left: 27vw;
  /* width: 2.67vw;
  height: 1.73vw; */
}

.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

.outer_3 {
  /*display: flex;*/
  /*align-items: flex-start;*/
  /*flex-direction: column;*/
  /*justify-content: center;*/
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  padding: 2vw 0;
  margin: 6.67vw auto;
}

.outer_attr {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
  width: 86.67vw;
  height:12.8vw;
}
.outer_3 .outer_attr:last-child .empty{
  width: 73.6vw;
  height: 0.53vw;
  border: 0;
}

.empty {
  border-top-width: 0.7px;
  border-top-style: solid;
  border-top-color: rgba(213, 213, 213, 1);
  width: 73.6vw;
  height: 0.53vw;
}

.group {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 3.47vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
}

.attr_name {
  opacity: 1;
  width: 7.47vw;
  height: 5.33vw;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.73vw;
  font-weight: 500;
}

.attr {
  opacity: 1;
  height: 5.33vw;
  line-height: 5.33vw;
  color: #929292;
  font-size: 3.73vw;
  font-weight: 400;
  max-width: 50vw;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 4vw;
  width: 86.4vw;
}
</style>



// WEBPACK FOOTER //
// BillDetail.vue?067683ab